// pt-BR de permissões delegadas (decisão D41-C4): completo para toda chave de en-grant.ts (checado pelo tipo). Linguagem
// simples: quem decide pode não ser da área técnica.
import type { enGrant } from "./en-grant.ts";

export const ptBRGrant: Record<keyof typeof enGrant, string> = {
  "grant.title": "Permissão para uma ação no servidor",
  "grant.field.action": "Ação",
  "grant.field.resource": "Recurso",
  "grant.field.reason": "Motivo do agente",
  "grant.field.secret": "Segredo",
  "grant.field.effect": "Efeito",
  "grant.field.terms": "Duração e limite",
  "grant.field.reversal": "Como desfazer",
  "grant.action.service.restart": "Reiniciar um serviço",
  "grant.action.service.redeploy": "Publicar de novo o commit {commit}",
  "grant.action.database.provision": "Criar um banco PostgreSQL chamado {name}",
  "grant.action.env.set_secret_ref": "Apontar a variável {key} para um segredo guardado",
  "grant.operation.service.restart": "Reiniciar um serviço",
  "grant.operation.service.redeploy": "Publicar um commit de novo",
  "grant.operation.database.provision": "Criar um banco de dados",
  "grant.operation.env.set_secret_ref": "Apontar uma variável para um segredo",
  "grant.effect.restart": "O serviço reinicia e fica indisponível por alguns instantes.",
  "grant.effect.redeploy": "A aplicação passa a rodar esse commit no lugar do atual.",
  "grant.effect.database_create": "Um banco novo é criado no ambiente do projeto; os dados existentes não mudam.",
  "grant.effect.env_set": "A variável passa a apontar para o segredo indicado; o valor do segredo não aparece no chat.",
  "grant.reversal.restart": "Nada a desfazer: o serviço volta a funcionar sozinho.",
  "grant.reversal.redeploy_previous": "É possível publicar de novo o commit anterior.",
  "grant.reversal.database_manual_delete": "Não é automática: o banco precisa ser removido à mão no Coolify.",
  "grant.reversal.env_restore_previous": "A referência anterior da variável pode ser restaurada.",
  "grant.term.once": "Só desta vez: 1 uso, válido por 24 horas.",
  "grant.term.mission": "Para esta tarefa: até 50 usos, válido por 24 horas.",
  "grant.term.persistent": "Sempre que precisar: até 100 usos, com revisão em 30 dias.",
  "grant.option.once": "Sim, só desta vez",
  "grant.option.mission": "Sim, durante esta tarefa",
  "grant.option.persistent": "Sim, sempre que precisar",
  "grant.option.deny": "Não, negar",
  "grant.choose": "Escolha uma resposta",
  "grant.adminOnly": "Só um administrador da organização pode decidir este pedido.",
  "grant.decided": "Decisão registrada: {option}.",
  "grant.unreadable": "Não foi possível ler os detalhes deste pedido, por isso ele não pode ser respondido aqui.",
  "grant.panel.title": "Permissões delegadas",
  "grant.panel.intro": "Permissões ativas que deixam um agente executar uma ação no servidor. Revogar uma interrompe o próximo uso na hora; uma ação já em andamento não é desfeita.",
  "grant.panel.empty": "Nenhuma permissão ativa.",
  "grant.panel.uses": "Usos: {uses} de {max}",
  "grant.panel.expires": "Expira em",
  "grant.panel.reviewDue": "Revisão até",
  "grant.panel.revoke": "Revogar",
  "grant.panel.revokeTitle": "Revogar esta permissão",
  "grant.panel.revokeBody": "O agente deixa de usar esta permissão no próximo pedido. Uma ação já em andamento não é desfeita.",
  "grant.panel.reason": "Motivo da revogação",
  "grant.panel.reasonHint": "Obrigatório. Fica registrado na trilha de auditoria.",
  "grant.panel.confirmRevoke": "Revogar permissão",
  "grant.panel.revoked": "Permissão revogada.",
  "grant.kind.once": "Só desta vez",
  "grant.kind.mission": "Durante uma tarefa",
  "grant.kind.persistent": "Sempre que precisar",
};
